import Yup from '../../../../vendor/yup';



export const PUSH_NOTIFICATIONS_CONTENT_TYPE = 'push-notification';

export const mkValidationSchema = (dynamicData = {}) => Yup.lazy(() => {
  return Yup.object().shape({
    template_id: Yup.number().required('Template is required'),
    title: Yup.string().nullable().max(2000),
    ...dynamicData,
  });
});
